export const PAYMENT = 'PAYMENT';
export const API_VERSION = 'API_VERSION';
export const UNKNOWN = 'UNKNOWN';
export const BAD_REQUEST = 'BAD_REQUEST';
export const AUTHENTICATION = 'AUTHENTICATION';
export const FORBIDDEN = 'FORBIDDEN';
export const GRAPHQL_VALIDATION_FAILED = 'GRAPHQL_VALIDATION_FAILED';
